<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    [icon]="data?.type === 'user' ? 'user' : 'info'"
    title="Информация"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <!-- Chat Details -->
    <app-chat-detail
      *ngIf="data"
      [modalMode]="true"
      [initData]="data.initData"
      [Service]="data.Service"
      [id]="data.id"
    ></app-chat-detail>
    <!-- Chat Details -->
  </div>
</div>